import styled from 'styled-components';
import orderId from './component';

export default styled(orderId)`
  color: var(--grey900);

  &.selected {
    color: var(--primary900);
  }

  &.open {
    color: white;
  }
`;
